export default __webpack_public_path__ + "static/media/oliver_l.a3f48eee.jpg";